import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import AfiLangs from "./_langs";
import {ButtonCancel, ButtonSubmit, GenericTableButton} from "../../../components/buttons/buttonsActions"
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {
    PH_CLOSING_TIME,
    PH_CODE, PH_LOGO,
    PH_NAME,
    PH_OPENING_TIME,
    PH_ORDER, PH_PHOTO_CODE, PH_SIVEX_CODE
} from "../../../components/i18n/placeHolders"
import {
    FORM,
    LB_CODE,
    INTERNATIONAL,
    LB_NAME,
    LB_ORDER,
    LB_STATUS,
    REQUIRED,
    LB_TYPE,
    LB_OPENING_TIME,
    LB_CLOSING_TIME,
    LB_LOGO,
    LB_IS_PARK,
    LB_NEED_RESERVATION,
    LB_PHOTO_CODE,
    LB_SIVEX_CODE,
    LB_UDN
} from "../../../components/i18n/i18n"

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {afiService} from "../../../jwt/_services/hotel/afiService"

// providers
import {afiClassProvider} from "../../../providers/afiClassProvider";

// utils
import {getStateByPath} from "../../../redux/selectors";
import {udnProvider} from "../../../providers/udnProvider";
import AfiPickupSchedule from "../afiPickupSchedule/AfiPickupSchedule";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import TranslateButton from "../../../components/buttons/TranslateButton";


const AfiForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { app, editMode, domainObject} = componentState?.data;

    const fbDataBase = {id: app?.fbDataBase?.id}
    const translatableLangs = domainObject?.translatedLangs || []

    const [afiClass, setAfiClass] = useState(domainObject?.afiClass?.id || null);
    const [udn, setUdn] = useState(domainObject?.udn?.id || null);
    const [status, setStatus] = useState(domainObject?.status || true);
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({});

    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            name: domainObject?.name,
            showOrder: domainObject?.showOrder,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                langs
            }
        };

        if(afiClass !== undefined && afiClass !== null)
            dataRequest.item.afiClass = { id: afiClass };

        if(udn !== undefined && udn !== null)
            dataRequest.item.udn = { id: udn };

        if(status !== undefined && status !== null)
            dataRequest.item.status = status;

        if (!editMode)
            genericIndexedActions.save(path, afiService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, afiService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={'card-modal-big'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <Separator/>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton item={domainObject} service={afiService} path={path}/>
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        <Row>
                            <Col sm={ editMode && '6'}>
                                <FormGroup>
                                    <SelectGeneric
                                        title={LB_TYPE}
                                        provider={afiClassProvider}
                                        initialValue={afiClass}
                                        setExternalValue={setAfiClass}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm={ editMode && '6'}>
                                <FormGroup>
                                    <SelectGeneric
                                        title={LB_UDN}
                                        provider={udnProvider}
                                        initialValue={udn}
                                        setExternalValue={setUdn}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>{LB_NAME}</Label>
                                    <Input
                                        type="text"
                                        name="name"
                                        placeholder={PH_NAME}
                                        innerRef={register}
                                    />
                                    { errors.name && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.name?.message}</div>}
                                </FormGroup>
                            </Col>
                            <Col sm={ editMode && '2'}>
                                <FormGroup>
                                    <Label>{LB_ORDER}</Label>
                                    <Input
                                        type="number"
                                        name="showOrder"
                                        placeholder={PH_ORDER}
                                        innerRef={register}
                                    />
                                    { errors.showOrder && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.showOrder?.message}</div>}
                                </FormGroup>
                            </Col>
                            <Col sm={ editMode && '2'}>
                                <FormGroup>
                                    <Label>{LB_STATUS}</Label>
                                    <br/>
                                    <Switch
                                        animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={status}
                                        onChange={ () => setStatus(!status) }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    {
                        editMode &&  <Col>
                            <AfiPickupSchedule path={path}/>
                        </Col>
                    }
                </Row>

                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-language mr-2"/>
                    { INTERNATIONAL }
                </CardTitle>
                <CardBody>
                    <AfiLangs
                        langs={langs}
                        setLangs={setLangs}
                        translatableLangs={translatableLangs}
                    />
                </CardBody>
                {
                    showModal && <LogHistoryModal
                        ref={ modalRef }
                        item={ domainObject }
                    />
                }
            </CardBody>
        </Card>
    </Form>
}

export default AfiForm